/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Set the company state
 *
 * @param  {Object} state
 * @param  {Object} company
 * @return {Void}
 */
const SET_COMPANY_DATA = (state, company) => {
    state.data = company
}

/**
 * Set the company's users state
 *
 * @param  {Object} state
 * @param  {Array} users
 * @return {Void}
 */
const SET_COMPANY_USERS_SUCCESS = (state, users) => {
    state.users = users
}

/**
 * Handle a failed company user request
 *
 * @param  {Object} state
 * @return {Void}
 */
const SET_COMPANY_USERS_FAILURE = (state) => {
    state.users = []
}

/**
 * Remove a user from the company user's state array
 *
 * @param  {Object} state
 * @return {Void}
 */
const REMOVE_COMPANY_USER_SUCCESS = (state) => {}

/**
 * Handle failed user deletion request
 *
 * @param  {Object} state
 * @return {Void}
 */
const REMOVE_COMPANY_USER_FAILURE = (state, err) => {
    console.log(err)
}

/**
 * Set the company info request state
 *
 * @param  {Object} state
 * @param  {Object} result
 * @return {Void}
 */
const UPDATE_COMPANY_INFO = (state, result) => {

}

/**
 * Handle company update success
 *
 * @param  {Object} state
 * @param  {Object} result
 * @return {Void}
 */
const UPDATE_COMPANY_INFO_SUCCESS = (state, company) => {
    state.data = company
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Handle failed request to update company data
 *
 * @param  {Object} state
 * @param  {Object} result
 * @return {Void}
 */
const UPDATE_COMPANY_INFO_FAILURE = (state, error) => {}

/**
 * Set the inbound invitations state object
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const INBOUND_INVITES_SUCCESS = (state, payload) => {
    if (payload.data) {
        state.inbound_invitations = payload
    } else {
        state.inbound_invitations.data = payload
    }
}

/**
 * Handle oubtound invite success response
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const OUTBOUND_INVITES_SUCCESS = (state, payload) => {
    if (payload.data) {
        state.outbound_invitations = payload
    } else {
        state.outbound_invitations.data = payload
    }
}

/**
 * Update an existing invite record in the state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const UPDATE_INVITE_EMAIL = (state, payload) => {
    let inv = state.outbound_invitations.data.find(invite => invite.id === payload.id)
    inv.invitee_email = payload.email
}

export default {
    RESET_STATE,
    SET_COMPANY_DATA,
    SET_COMPANY_USERS_SUCCESS,
    SET_COMPANY_USERS_FAILURE,
    REMOVE_COMPANY_USER_SUCCESS,
    REMOVE_COMPANY_USER_FAILURE,
    UPDATE_COMPANY_INFO,
    UPDATE_COMPANY_INFO_SUCCESS,
    UPDATE_COMPANY_INFO_FAILURE,
    INBOUND_INVITES_SUCCESS,
    OUTBOUND_INVITES_SUCCESS,
    UPDATE_INVITE_EMAIL
}



// WEBPACK FOOTER //
// ./src/state/modules/company/mutations.js